// extracted by mini-css-extract-plugin
export var fullBlock = "pagesection-module--fullBlock--8006b";
export var fullBlockDesktopOnly = "pagesection-module--fullBlockDesktopOnly--d6fc1";
export var fullBlockMobileOnly = "pagesection-module--fullBlockMobileOnly--a2a0b";
export var header = "pagesection-module--header--080a8";
export var listMargin = "pagesection-module--listMargin--aac6e";
export var noMargin = "pagesection-module--noMargin--d8f64";
export var sectionMargin = "pagesection-module--sectionMargin--981e5";
export var text = "pagesection-module--text--15da7";